@if (isOpen()) {
  <div class="global-search" [class.mobile]="!isDesktop()" (click)="onScrimClick($event)">
    <div class="search-scrim" aria-hidden="true"></div>
    <div
      class="search-panel"
      role="dialog"
      aria-modal="true"
      aria-label="Globale Suche"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()">
      @if (!isDesktop()) {
        <div class="mobile-header">
          <button type="button" class="back-button" aria-label="Suche schließen" (click)="close()">
            <app-icon alt="" [ariaHidden]="true" src="back.svg" [height]="22" [width]="22" />
          </button>
          <app-search-input-row
            variant="mobile"
            [query]="query()"
            [placeholder]="searchPlaceholder"
            (queryChange)="onQueryChange($event)"
            (clearRequested)="clearQuery()" />
        </div>
      } @else {
        <app-search-input-row
          variant="desktop"
          [query]="query()"
          [placeholder]="searchPlaceholder"
          (queryChange)="onQueryChange($event)"
          (clearRequested)="clearQuery()" />
      }

      <div #resultsScroll class="results-scroll">
        @if (status() === 'loading') {
          <div class="loading-state">
            <app-spinner />
          </div>
        }

        @if (status() === 'empty') {
          <app-search-empty-state
            [recent]="recent()"
            [suggestions]="suggestions()"
            (recentSelected)="onRecentClick($event)"
            (suggestionSelected)="onSuggestionClick($event)" />
        }

        @if (status() === 'results') {
          @for (group of resultGroups; track group.key) {
            @if (getGroupItems(group.key).length > 0) {
              <div class="group-header">
                <app-icon alt="" [ariaHidden]="true" [src]="group.icon" [height]="15" [width]="15" className="group-icon" />
                <span class="group-label">{{ group.label }}</span>
                <span class="group-count">{{ getGroupItems(group.key).length }}</span>
              </div>
              @for (item of getGroupItems(group.key); track item.id; let i = $index) {
                <div [attr.data-active]="isActive(group.key, i) ? 'true' : null">
                  <app-search-result-row
                    [item]="item"
                    [active]="isActive(group.key, i)"
                    (selected)="onResultSelect($event)" />
                </div>
              }
            }
          }
        }

        @if (status() === 'no-results') {
          <app-search-no-results [query]="query()" />
        }
      </div>

      @if (isDesktop()) {
        <app-search-footer-hints [status]="status()" [totalCount]="totalCount()" />
      }
    </div>
  </div>
}
